import { heroData } from '@/mocks/home';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-primary-100/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-0 w-72 h-72 bg-accent-100/30 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Text Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-bold rounded-full mb-4 whitespace-nowrap">
              {heroData.tag}
            </span>

            {/* H1 */}
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3 max-w-[600px] mx-auto lg:mx-0">
              {heroData.h1}
            </h1>

            {/* Slogan */}
            <p className="text-sm md:text-base text-primary-600 font-medium mb-5">
              {heroData.slogan}
            </p>

            {/* Intro */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6">
              {heroData.intro}
            </p>

            {/* Stats */}
            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-lg md:text-xl font-bold text-foreground-950">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleClick(heroData.ctaPrimary.href)}
                className="px-6 py-3 bg-primary-500 text-background-50 font-bold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line mr-2"></i>
                {heroData.ctaPrimary.text}
              </button>
              <button
                onClick={() => handleClick(heroData.ctaSecondary.href)}
                className="px-6 py-3 bg-background-50 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-right-line mr-2"></i>
                {heroData.ctaSecondary.text}
              </button>
            </div>
          </div>

          {/* Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[5/4] rounded-2xl overflow-hidden bg-gradient-to-br from-primary-400/20 via-accent-300/20 to-secondary-300/20">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20composition%20of%20social%20media%20trending%20topics%20and%20entertainment%20news%2C%20warm%20coral%20and%20golden%20tones%2C%20modern%20editorial%20design%20with%20geometric%20shapes%20and%20fluid%20gradients%2C%20dynamic%20energy%2C%20young%20and%20trendy%20aesthetic%2C%20clean%20composition%20with%20soft%20texture%20overlays%2C%20high%20detail%20digital%20art&width=1040&height=832&seq=hero-visual-51cg&orientation=landscape"
                alt="51吃瓜app - 全网热门吃瓜资讯聚合平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay for contrast */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}